/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSetupRouteImport } from './routes/_authenticated/setup'
import { Route as AuthenticatedRacaoRouteImport } from './routes/_authenticated/racao'
import { Route as AuthenticatedPerfilRouteImport } from './routes/_authenticated/perfil'
import { Route as AuthenticatedPedidosRouteImport } from './routes/_authenticated/pedidos'
import { Route as AuthenticatedMortalidadesRouteImport } from './routes/_authenticated/mortalidades'
import { Route as AuthenticatedGalpoesRouteImport } from './routes/_authenticated/galpoes'
import { Route as AuthenticatedFornecedoresRouteImport } from './routes/_authenticated/fornecedores'
import { Route as AuthenticatedEstoqueRouteImport } from './routes/_authenticated/estoque'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedContasReceberRouteImport } from './routes/_authenticated/contas-receber'
import { Route as AuthenticatedContasPagarRouteImport } from './routes/_authenticated/contas-pagar'
import { Route as AuthenticatedConsumoRouteImport } from './routes/_authenticated/consumo'
import { Route as AuthenticatedComprasRouteImport } from './routes/_authenticated/compras'
import { Route as AuthenticatedColetasRouteImport } from './routes/_authenticated/coletas'
import { Route as AuthenticatedColaboradoresRouteImport } from './routes/_authenticated/colaboradores'
import { Route as AuthenticatedClientesRouteImport } from './routes/_authenticated/clientes'
import { Route as AuthenticatedClassificacoesRouteImport } from './routes/_authenticated/classificacoes'
import { Route as AuthenticatedCaixaRouteImport } from './routes/_authenticated/caixa'
import { Route as AuthenticatedAlertasRouteImport } from './routes/_authenticated/alertas'
import { Route as AuthenticatedAguardandoConfiguracaoRouteImport } from './routes/_authenticated/aguardando-configuracao'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSetupRoute = AuthenticatedSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRacaoRoute = AuthenticatedRacaoRouteImport.update({
  id: '/racao',
  path: '/racao',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPerfilRoute = AuthenticatedPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPedidosRoute = AuthenticatedPedidosRouteImport.update({
  id: '/pedidos',
  path: '/pedidos',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMortalidadesRoute =
  AuthenticatedMortalidadesRouteImport.update({
    id: '/mortalidades',
    path: '/mortalidades',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGalpoesRoute = AuthenticatedGalpoesRouteImport.update({
  id: '/galpoes',
  path: '/galpoes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFornecedoresRoute =
  AuthenticatedFornecedoresRouteImport.update({
    id: '/fornecedores',
    path: '/fornecedores',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEstoqueRoute = AuthenticatedEstoqueRouteImport.update({
  id: '/estoque',
  path: '/estoque',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedContasReceberRoute =
  AuthenticatedContasReceberRouteImport.update({
    id: '/contas-receber',
    path: '/contas-receber',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContasPagarRoute =
  AuthenticatedContasPagarRouteImport.update({
    id: '/contas-pagar',
    path: '/contas-pagar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConsumoRoute = AuthenticatedConsumoRouteImport.update({
  id: '/consumo',
  path: '/consumo',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedComprasRoute = AuthenticatedComprasRouteImport.update({
  id: '/compras',
  path: '/compras',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedColetasRoute = AuthenticatedColetasRouteImport.update({
  id: '/coletas',
  path: '/coletas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedColaboradoresRoute =
  AuthenticatedColaboradoresRouteImport.update({
    id: '/colaboradores',
    path: '/colaboradores',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientesRoute = AuthenticatedClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClassificacoesRoute =
  AuthenticatedClassificacoesRouteImport.update({
    id: '/classificacoes',
    path: '/classificacoes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCaixaRoute = AuthenticatedCaixaRouteImport.update({
  id: '/caixa',
  path: '/caixa',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAlertasRoute = AuthenticatedAlertasRouteImport.update({
  id: '/alertas',
  path: '/alertas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAguardandoConfiguracaoRoute =
  AuthenticatedAguardandoConfiguracaoRouteImport.update({
    id: '/aguardando-configuracao',
    path: '/aguardando-configuracao',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/aguardando-configuracao': typeof AuthenticatedAguardandoConfiguracaoRoute
  '/alertas': typeof AuthenticatedAlertasRoute
  '/caixa': typeof AuthenticatedCaixaRoute
  '/classificacoes': typeof AuthenticatedClassificacoesRoute
  '/clientes': typeof AuthenticatedClientesRoute
  '/colaboradores': typeof AuthenticatedColaboradoresRoute
  '/coletas': typeof AuthenticatedColetasRoute
  '/compras': typeof AuthenticatedComprasRoute
  '/consumo': typeof AuthenticatedConsumoRoute
  '/contas-pagar': typeof AuthenticatedContasPagarRoute
  '/contas-receber': typeof AuthenticatedContasReceberRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/estoque': typeof AuthenticatedEstoqueRoute
  '/fornecedores': typeof AuthenticatedFornecedoresRoute
  '/galpoes': typeof AuthenticatedGalpoesRoute
  '/mortalidades': typeof AuthenticatedMortalidadesRoute
  '/pedidos': typeof AuthenticatedPedidosRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/racao': typeof AuthenticatedRacaoRoute
  '/setup': typeof AuthenticatedSetupRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/aguardando-configuracao': typeof AuthenticatedAguardandoConfiguracaoRoute
  '/alertas': typeof AuthenticatedAlertasRoute
  '/caixa': typeof AuthenticatedCaixaRoute
  '/classificacoes': typeof AuthenticatedClassificacoesRoute
  '/clientes': typeof AuthenticatedClientesRoute
  '/colaboradores': typeof AuthenticatedColaboradoresRoute
  '/coletas': typeof AuthenticatedColetasRoute
  '/compras': typeof AuthenticatedComprasRoute
  '/consumo': typeof AuthenticatedConsumoRoute
  '/contas-pagar': typeof AuthenticatedContasPagarRoute
  '/contas-receber': typeof AuthenticatedContasReceberRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/estoque': typeof AuthenticatedEstoqueRoute
  '/fornecedores': typeof AuthenticatedFornecedoresRoute
  '/galpoes': typeof AuthenticatedGalpoesRoute
  '/mortalidades': typeof AuthenticatedMortalidadesRoute
  '/pedidos': typeof AuthenticatedPedidosRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/racao': typeof AuthenticatedRacaoRoute
  '/setup': typeof AuthenticatedSetupRoute
  '/': typeof AuthenticatedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/aguardando-configuracao': typeof AuthenticatedAguardandoConfiguracaoRoute
  '/_authenticated/alertas': typeof AuthenticatedAlertasRoute
  '/_authenticated/caixa': typeof AuthenticatedCaixaRoute
  '/_authenticated/classificacoes': typeof AuthenticatedClassificacoesRoute
  '/_authenticated/clientes': typeof AuthenticatedClientesRoute
  '/_authenticated/colaboradores': typeof AuthenticatedColaboradoresRoute
  '/_authenticated/coletas': typeof AuthenticatedColetasRoute
  '/_authenticated/compras': typeof AuthenticatedComprasRoute
  '/_authenticated/consumo': typeof AuthenticatedConsumoRoute
  '/_authenticated/contas-pagar': typeof AuthenticatedContasPagarRoute
  '/_authenticated/contas-receber': typeof AuthenticatedContasReceberRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/estoque': typeof AuthenticatedEstoqueRoute
  '/_authenticated/fornecedores': typeof AuthenticatedFornecedoresRoute
  '/_authenticated/galpoes': typeof AuthenticatedGalpoesRoute
  '/_authenticated/mortalidades': typeof AuthenticatedMortalidadesRoute
  '/_authenticated/pedidos': typeof AuthenticatedPedidosRoute
  '/_authenticated/perfil': typeof AuthenticatedPerfilRoute
  '/_authenticated/racao': typeof AuthenticatedRacaoRoute
  '/_authenticated/setup': typeof AuthenticatedSetupRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/admin'
    | '/aguardando-configuracao'
    | '/alertas'
    | '/caixa'
    | '/classificacoes'
    | '/clientes'
    | '/colaboradores'
    | '/coletas'
    | '/compras'
    | '/consumo'
    | '/contas-pagar'
    | '/contas-receber'
    | '/dashboard'
    | '/estoque'
    | '/fornecedores'
    | '/galpoes'
    | '/mortalidades'
    | '/pedidos'
    | '/perfil'
    | '/racao'
    | '/setup'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/admin'
    | '/aguardando-configuracao'
    | '/alertas'
    | '/caixa'
    | '/classificacoes'
    | '/clientes'
    | '/colaboradores'
    | '/coletas'
    | '/compras'
    | '/consumo'
    | '/contas-pagar'
    | '/contas-receber'
    | '/dashboard'
    | '/estoque'
    | '/fornecedores'
    | '/galpoes'
    | '/mortalidades'
    | '/pedidos'
    | '/perfil'
    | '/racao'
    | '/setup'
    | '/'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/register'
    | '/_authenticated/admin'
    | '/_authenticated/aguardando-configuracao'
    | '/_authenticated/alertas'
    | '/_authenticated/caixa'
    | '/_authenticated/classificacoes'
    | '/_authenticated/clientes'
    | '/_authenticated/colaboradores'
    | '/_authenticated/coletas'
    | '/_authenticated/compras'
    | '/_authenticated/consumo'
    | '/_authenticated/contas-pagar'
    | '/_authenticated/contas-receber'
    | '/_authenticated/dashboard'
    | '/_authenticated/estoque'
    | '/_authenticated/fornecedores'
    | '/_authenticated/galpoes'
    | '/_authenticated/mortalidades'
    | '/_authenticated/pedidos'
    | '/_authenticated/perfil'
    | '/_authenticated/racao'
    | '/_authenticated/setup'
    | '/_authenticated/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setup': {
      id: '/_authenticated/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthenticatedSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/racao': {
      id: '/_authenticated/racao'
      path: '/racao'
      fullPath: '/racao'
      preLoaderRoute: typeof AuthenticatedRacaoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/perfil': {
      id: '/_authenticated/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AuthenticatedPerfilRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pedidos': {
      id: '/_authenticated/pedidos'
      path: '/pedidos'
      fullPath: '/pedidos'
      preLoaderRoute: typeof AuthenticatedPedidosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mortalidades': {
      id: '/_authenticated/mortalidades'
      path: '/mortalidades'
      fullPath: '/mortalidades'
      preLoaderRoute: typeof AuthenticatedMortalidadesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/galpoes': {
      id: '/_authenticated/galpoes'
      path: '/galpoes'
      fullPath: '/galpoes'
      preLoaderRoute: typeof AuthenticatedGalpoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fornecedores': {
      id: '/_authenticated/fornecedores'
      path: '/fornecedores'
      fullPath: '/fornecedores'
      preLoaderRoute: typeof AuthenticatedFornecedoresRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/estoque': {
      id: '/_authenticated/estoque'
      path: '/estoque'
      fullPath: '/estoque'
      preLoaderRoute: typeof AuthenticatedEstoqueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contas-receber': {
      id: '/_authenticated/contas-receber'
      path: '/contas-receber'
      fullPath: '/contas-receber'
      preLoaderRoute: typeof AuthenticatedContasReceberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contas-pagar': {
      id: '/_authenticated/contas-pagar'
      path: '/contas-pagar'
      fullPath: '/contas-pagar'
      preLoaderRoute: typeof AuthenticatedContasPagarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/consumo': {
      id: '/_authenticated/consumo'
      path: '/consumo'
      fullPath: '/consumo'
      preLoaderRoute: typeof AuthenticatedConsumoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compras': {
      id: '/_authenticated/compras'
      path: '/compras'
      fullPath: '/compras'
      preLoaderRoute: typeof AuthenticatedComprasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coletas': {
      id: '/_authenticated/coletas'
      path: '/coletas'
      fullPath: '/coletas'
      preLoaderRoute: typeof AuthenticatedColetasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/colaboradores': {
      id: '/_authenticated/colaboradores'
      path: '/colaboradores'
      fullPath: '/colaboradores'
      preLoaderRoute: typeof AuthenticatedColaboradoresRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clientes': {
      id: '/_authenticated/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof AuthenticatedClientesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/classificacoes': {
      id: '/_authenticated/classificacoes'
      path: '/classificacoes'
      fullPath: '/classificacoes'
      preLoaderRoute: typeof AuthenticatedClassificacoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/caixa': {
      id: '/_authenticated/caixa'
      path: '/caixa'
      fullPath: '/caixa'
      preLoaderRoute: typeof AuthenticatedCaixaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alertas': {
      id: '/_authenticated/alertas'
      path: '/alertas'
      fullPath: '/alertas'
      preLoaderRoute: typeof AuthenticatedAlertasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/aguardando-configuracao': {
      id: '/_authenticated/aguardando-configuracao'
      path: '/aguardando-configuracao'
      fullPath: '/aguardando-configuracao'
      preLoaderRoute: typeof AuthenticatedAguardandoConfiguracaoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedAguardandoConfiguracaoRoute: typeof AuthenticatedAguardandoConfiguracaoRoute
  AuthenticatedAlertasRoute: typeof AuthenticatedAlertasRoute
  AuthenticatedCaixaRoute: typeof AuthenticatedCaixaRoute
  AuthenticatedClassificacoesRoute: typeof AuthenticatedClassificacoesRoute
  AuthenticatedClientesRoute: typeof AuthenticatedClientesRoute
  AuthenticatedColaboradoresRoute: typeof AuthenticatedColaboradoresRoute
  AuthenticatedColetasRoute: typeof AuthenticatedColetasRoute
  AuthenticatedComprasRoute: typeof AuthenticatedComprasRoute
  AuthenticatedConsumoRoute: typeof AuthenticatedConsumoRoute
  AuthenticatedContasPagarRoute: typeof AuthenticatedContasPagarRoute
  AuthenticatedContasReceberRoute: typeof AuthenticatedContasReceberRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedEstoqueRoute: typeof AuthenticatedEstoqueRoute
  AuthenticatedFornecedoresRoute: typeof AuthenticatedFornecedoresRoute
  AuthenticatedGalpoesRoute: typeof AuthenticatedGalpoesRoute
  AuthenticatedMortalidadesRoute: typeof AuthenticatedMortalidadesRoute
  AuthenticatedPedidosRoute: typeof AuthenticatedPedidosRoute
  AuthenticatedPerfilRoute: typeof AuthenticatedPerfilRoute
  AuthenticatedRacaoRoute: typeof AuthenticatedRacaoRoute
  AuthenticatedSetupRoute: typeof AuthenticatedSetupRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedAguardandoConfiguracaoRoute:
    AuthenticatedAguardandoConfiguracaoRoute,
  AuthenticatedAlertasRoute: AuthenticatedAlertasRoute,
  AuthenticatedCaixaRoute: AuthenticatedCaixaRoute,
  AuthenticatedClassificacoesRoute: AuthenticatedClassificacoesRoute,
  AuthenticatedClientesRoute: AuthenticatedClientesRoute,
  AuthenticatedColaboradoresRoute: AuthenticatedColaboradoresRoute,
  AuthenticatedColetasRoute: AuthenticatedColetasRoute,
  AuthenticatedComprasRoute: AuthenticatedComprasRoute,
  AuthenticatedConsumoRoute: AuthenticatedConsumoRoute,
  AuthenticatedContasPagarRoute: AuthenticatedContasPagarRoute,
  AuthenticatedContasReceberRoute: AuthenticatedContasReceberRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEstoqueRoute: AuthenticatedEstoqueRoute,
  AuthenticatedFornecedoresRoute: AuthenticatedFornecedoresRoute,
  AuthenticatedGalpoesRoute: AuthenticatedGalpoesRoute,
  AuthenticatedMortalidadesRoute: AuthenticatedMortalidadesRoute,
  AuthenticatedPedidosRoute: AuthenticatedPedidosRoute,
  AuthenticatedPerfilRoute: AuthenticatedPerfilRoute,
  AuthenticatedRacaoRoute: AuthenticatedRacaoRoute,
  AuthenticatedSetupRoute: AuthenticatedSetupRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
